module.exports = __webpack_public_path__ + "static/media/location-inactive.5c90b89a.svg";